// @ts-ignore
import Modal from 'react-modal';

export default function onClientEntry(_, opts) {
  const { appElement = '#___gatsby' } = opts;
  Modal.setAppElement(appElement);
};
